import { Empty, Button } from "antd";
import type { ReactNode } from "react";

interface EmptyStateProps {
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: ReactNode;
  };
  image?: ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ description, action, image }) => {
  return (
    <div style={{ padding: "60px 20px", textAlign: "center" }}>
      <Empty
        image={image || Empty.PRESENTED_IMAGE_SIMPLE}
        description={description || "No data available"}
      >
        {action && (
          <Button type="primary" icon={action.icon} onClick={action.onClick}>
            {action.label}
          </Button>
        )}
      </Empty>
    </div>
  );
};
